import React, { useContext } from 'react';
import { PANEL } from './constants.js';
import { TabsContext } from './context.js';
import { Box } from '../Box/Box.js';

function TabsPanel({ children, tabKey }) {
    const ctx = useContext(TabsContext);
    const tabId = `${tabKey}`;
    const panelId = `${PANEL}${tabKey}`;
    if (ctx.currentTab !== tabKey)
        return null;
    return (React.createElement(Box, { id: panelId, role: "tabpanel", tabIndex: 0, "aria-labelledby": tabId }, children));
}

export { TabsPanel as default };
